import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend } from "chart.js";
import { useTranslation } from "react-i18next";
import { WeightIcon } from "lucide-react";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

interface WeightChartProps {
    weightLog: { date: string; weight: number }[];
}

export const WeightChart = ({ weightLog }: WeightChartProps) => {
    const { t } = useTranslation();

    const data = {
        labels: weightLog.map((entry) => entry.date),
        datasets: [
            {
                label: t("charts.weight.label"),
                data: weightLog.map((entry) => entry.weight),
                borderColor: "rgba(75, 192, 192, 1)",
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                pointBorderColor: "rgba(75, 192, 192, 1)",
                pointBackgroundColor: "#fff",
                tension: 0.4, // Smooth curves
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top" as const,
                labels: {
                    color: "#333",
                },
            },
            tooltip: {
                callbacks: {
                    title: (tooltipItems) => t("charts.weight.date", { date: tooltipItems[0].label }),
                    label: (tooltipItem) => `${tooltipItem.dataset.label}: ${tooltipItem.raw} kg`,
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: t("charts.weight.xAxis"),
                    color: "#666",
                },
                ticks: {
                    color: "#333",
                },
            },
            y: {
                title: {
                    display: true,
                    text: t("charts.weight.yAxis"),
                    color: "#666",
                },
                ticks: {
                    color: "#333",
                },
            },
        },
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold mb-4">{t("charts.weight.title")}</h2>
                <WeightIcon className="text-primary" size={24} />
            </div>

            <Line data={data} options={options} />
        </div>
    );
};
